
interface positions {
           selling_price : boolean;
            buying_price : boolean;
        }

interface headerFields {
    key : string;
    type : string;
    regex : string;
    addon? : string;
    default? : string|number|boolean;
    disabled? : boolean|undefined;
}

interface invoiceTypeInterface {
        has_buying_price_netto : boolean;
    has_buying_price_brutto : boolean;
    has_selling_price_brutto : boolean;
    has_selling_price_netto : boolean;
      positions : positions;

    has_buying_price: boolean;
    has_selling_price: boolean;
    has_buying_tax : boolean;
    has_selling_tax: boolean;
    has_overwrite_destination: boolean;
    headerFields? : headerFields[]; // Overwrites default headers fields for a invoice
    allow_rounding_brutto: boolean;
}

export class InvoiceTypeClass implements invoiceTypeInterface {
    has_buying_price_netto = true;
    has_buying_price_brutto = true;
    has_selling_price_brutto = true;
    has_selling_price_netto = true;
      positions = {
            selling_price : true,
            buying_price : true
        };
    has_buying_price = true;
    has_selling_price = true;
    has_buying_tax = false;
    has_selling_tax = true;
    has_overwrite_destination = false;
    headerFields: headerFields[] = [];
    allow_rounding_brutto = false;
}

export class GrInvoiceTypeClass extends InvoiceTypeClass{
        has_overwrite_destination = true;
        allow_rounding_brutto = true;
    headerFields : headerFields[] =  [
                        {
                            key: "number",
                            type: "text",
                            regex: ":*",
                            disabled: true,
                        },
                        {
                            key: "date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            default: false,
                        },
                        {
                            key: "due_date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            disabled: true,
                            default: false
                        },
                        {
                            key: "tax",
                            type: "number",
                            regex: ":*",
                            addon: "%",
                            default: 20,
                        },
                        {
                            key: "gr_contract_nr",
                            type: "text",
                            regex: ":*",
                        },
                        {
                            key: "delivery_date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            default: "now",
                        }
                    ];
}

export class GrCommissionOnlyInvoiceClass extends GrInvoiceTypeClass {
    invoice_is_commission_amount = true;
    has_buying_price_netto = false;
    has_buying_price_brutto = false;
    has_buying_tax = false;
    allow_rounding_brutto = true;
}

export class OrderTypeClass extends InvoiceTypeClass{
    has_buying_price_netto = true;
    has_buying_price_brutto = true;
    has_buying_tax = true;
}

export class GrOrderTypeClass extends OrderTypeClass{
    has_overwrite_destination = true;
    headerFields =  [
                        {
                            key: "date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            default: "now",
                        },
                        {
                            key: "tax",
                            type: "number",
                            regex: ":*",
                            addon: "%",
                            default: 20,
                        },
                        {
                            key: "number",
                            type: "text",
                            regex: ":*",
                            disabled: true,
                        },
                        {
                            key: "gr_contract_nr",
                            type: "text",
                            regex: ":*",
                        },
                        {
                            key: "delivery_date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            default: "now",
                        },
                        {
                            key: "loading_date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            default: "now",
                        }
                    ];

}

export class PurchaseTypeClass extends InvoiceTypeClass{
        has_buying_price_netto = true;
    has_buying_price_brutto = true;
    has_selling_price_brutto = false;
    has_selling_price_netto = false;
      positions = {
            selling_price : false,
            buying_price : true
        };
    has_buying_price = true;
    has_selling_price = false;
    has_buying_tax = true;
    has_selling_tax = false;
}

export class DiffPurchaseTypeClass extends PurchaseTypeClass{
    
}

export class GrPurchaseTypeClass extends PurchaseTypeClass{
    has_overwrite_destination = true;
    allow_rounding_brutto = true;
}

export class KrktStockInvoice extends InvoiceTypeClass{
}

export class DebitNoteType extends InvoiceTypeClass {
    has_buying_price = true;
    has_selling_price = false;
    has_selling_price_brutto = false;
    has_selling_price_netto = false;
    has_buying_tax = true;
    has_selling_tax = false;
    has_buying_price_netto = true;
    has_buying_price_brutto = true;
}

export class CreditNoteType extends InvoiceTypeClass {
    disabled_buyings = true;
    has_buying_price = false;
    has_selling_price = true;
    has_selling_price_brutto = true;
    has_selling_price_netto = true;
    has_buying_tax = false;
    has_selling_tax = true;
    has_buying_price_netto = false;
    has_buying_price_brutto = false;
}
export class MGInvoiceTypeClass extends InvoiceTypeClass{
    headerFields : headerFields[] =  [
                        {
                            key: "number",
                            type: "text",
                            regex: ":*",
                            disabled: true,
                        },
                        {
                            key: "date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            default: false,
                        },
                        {
                            key: "due_date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            disabled: true,
                            default: false
                        },
                        {
                            key: "tax",
                            type: "number",
                            regex: ":*",
                            addon: "%",
                            default: 20,
                        },
                        {
                            key: "gr_contract_nr",
                            type: "text",
                            regex: ":*",
                        },
                        {
                            key: "delivery_date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            default: "now",
                        }
                    ];
}
export class MgOrderTypeClass extends OrderTypeClass{
    has_overwrite_destination = true;
    headerFields =  [
                        {
                            key: "date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            default: "now",
                        },
                        {
                            key: "tax",
                            type: "number",
                            regex: ":*",
                            addon: "%",
                            default: 20,
                        },
                        {
                            key: "gr_contract_nr",
                            type: "text",
                            regex: ":*",
                        },
                        {
                            key: "delivery_date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            default: "now",
                        },
                        {
                            key: "loading_date",
                            type: "dateselector",
                            regex: ":*",
                            addon: "",
                            default: "now",
                        }
                    ];

}
export class MgCreditNoteType extends CreditNoteType {
}

export class MgDebitNoteType extends DebitNoteType {
}
export class MgPurchaseTypeClass extends PurchaseTypeClass{
}
